import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
Vue.use(Router)
const router = new Router({
    routes,
    mode: 'hash'
})
/*router.beforeEach((to, from, next) => {
    iView.LoadingBar.start()
    next()
})

router.afterEach(to => {
    iView.LoadingBar.finish()
    window.scrollTo(0, 0)
})*/

//路由权限设置
let roleID = ['10001','10004']
//头部要用
global.roleID = roleID
router.beforeEach((to, from, next) => {
    if (to.path.indexOf('admin') != -1)  {
        let roles = global.CONFIG.userConf.roles
        let flag = roles.some(res=>{
            return roleID.includes(res.roleID)
        })
        if (flag) {
            next()
        }else{
            next({ path: "/landPrice" })
        }
    } else {
        next()
    }
})

//解决重复路由报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
